@if (sizeGroups && sizeGroups.length) {
<!-- Group Selection -->
@if (title) {
<h3 class="s1 center">{{title | translate}}</h3>
}

<div class="flex flex-justify-center"
     [class.p-t-9]="!!title"
     style="gap: 16px;">
    @for (group of sizeGroups; track group.group) {
    <profile-group-option [label]="group.group"
                          [selected]="isGroupSelected(group.group)"
                          (click)="selectGroup(group.group)">
    </profile-group-option>
    }
</div>

<!-- Size Types for Selected Group -->
@if (selectedGroup) {
@for (type of getSelectedGroupData()!.types; track type.title) {
<div class="m-t-5">
    <profile-size-options [sizeType]="type"
                          [value]="getSizeForType(type.title)"
                          (valueChange)="setSizeForType(type.title, $event)">
    </profile-size-options>
</div>
}
}
}
